<template>
  <div class="home">
    <vue-headful
      :title="'List2Go - ' + $t('title')"
      description="A trip, party or just shopping? List2Go is the easiest way to create a list together. Name it, add it, share it"
      :lang="$t('lang')"
    />
    <Home />
  </div>
</template>

<script>
// @ is an alias to /src
import Home from "@/components/Home.vue";

export default {
	name: "home",
	metaInfo: {
		meta: [{ name: "robots", content: "index, follow" }],
	},
	components: {
		Home,
	},
};
</script>
